// extracted by mini-css-extract-plugin
export default {"mpImage":"Massages_mpImage__xc95i"};